module.exports = __webpack_public_path__ + "static/media/bacon.bdf335a8.png";